export interface DepositCredentials {
    amount: number;
    period: number;
    percent: number;
    daysInMonth: number;
    daysInYear: number;
}

export const getDateByGivenMonth = (month: number) => {
    let d = new Date();
    return new Date(d.setMonth(d.getMonth() + month));
}